import { render, staticRenderFns } from "./WizardRequestData.vue?vue&type=template&id=bd3dca12&"
import script from "./WizardRequestData.vue?vue&type=script&lang=js&"
export * from "./WizardRequestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports